module.exports = __webpack_public_path__ + "img/c03_unitstartechstonethrowerchampion_Normal_ua.b27ed213.webp";